import nameBadge from './name-badge.html';
import wood from './wood.html';

export default {
  "name-badge": nameBadge,
  wood
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/products/components/material-pricing/templates/name-badges/index.js
 **/